export default "__VITE_ASSET__bda7c59f__"